import { Konva } from './_CoreInternals.js';
export { Konva } from './_CoreInternals.js';
export default Konva;
